import Vue from 'vue'
import VueGtm from "vue-gtm";

Vue.use(VueGtm, {
  id: process.env.GOOGLE_TAG_MANAGER,
  enabled: process.env.NODE_ENV !== 'production',
});



// WEBPACK FOOTER //
// ./src/plugins/gtm.js